import { Modal } from '@/components/ui';
import { useOutboxStatus } from '@/offline/sender';
import { useSavedOffline } from '@/stores/savedOffline';

/** Shows whatever announceSavedOffline() is saying. Mounted once, by App. */
export function SavedOfflineHost() {
  const open = useSavedOffline((s) => s.open);
  const waiting = useOutboxStatus((s) => s.waiting);
  if (!open) return null;

  const close = () => open.resolve('close');
  return (
    <Modal title="Saved on this PC" onClose={close}>
      <div className="stack savedoffline" data-testid="saved-offline">
        <h2 className="savedoffline__title">
          <span aria-hidden="true" className="savedoffline__icon">
            ✓
          </span>
          Saved on this PC
        </h2>
        <p>
          <strong>{open.what}</strong> is kept safely on this PC.
        </p>
        <p>
          {open.slowLine
            ? 'The server has not answered yet. It will be sent by itself as soon as it does — there is nothing more to do.'
            : 'There is no connection right now. It will be sent by itself as soon as the connection is back — there is nothing more to do, and closing the app does not lose it.'}
        </p>
        {open.note && <p className="muted">{open.note}</p>}
        {waiting > 0 && (
          <p className="muted">
            {waiting} {waiting === 1 ? 'piece of work is' : 'pieces of work are'} waiting to be sent from this PC.
          </p>
        )}
        <div className="formactions">
          <button type="button" className="btn" onClick={() => open.resolve('waiting')}>
            See offline work
          </button>
          <span className="formactions__spacer" />
          {open.canEnterAnother && (
            <button type="button" className="btn" onClick={close}>
              {open.closeLabel ?? 'Back to list'}
            </button>
          )}
          <button
            type="button"
            className="btn btn--primary"
            // The likeliest next step, so Enter takes it.
            autoFocus
            onClick={() => (open.canEnterAnother ? open.resolve('another') : close())}
          >
            {open.canEnterAnother ? 'Enter another' : (open.closeLabel ?? 'OK')}
          </button>
        </div>
      </div>
    </Modal>
  );
}
